import React from 'react'
import t from 'prop-types'

// import ContenedorIndice from './contenedor-indice'
import LeccionFlipped from './leccion-flipped';

function Contenedores({ libroId, indexUnidad, contenedores, onEntrada }) {
    return (
        <div className="contenedorIndice">
        { contenedores.map( ({unidades}) => (
            <div class="columna">
                { unidades.map( unidad => <LeccionFlipped {...unidad } onEntrada={ onEntrada } />) }
            </div>
        ))}
        </div>
    )
}

Contenedores.propTypes = {
    libroId: t.any,
    indexUnidad: t.any,
    contenedores: t.array,
    onEntrada: t.func
}

export default Contenedores